//import vendors 
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'

//import css e  scss
import './css/font-awesome.css'
import './css/nucleo-icons.css'
import './css/nucleo-svg.css'
import './css/simple-line.min.css'
import './scss/index.scss'


